// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021coffee_award/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getWorks = () => {
  return http.get(`${urlPrefix}getWorks`);
};

const getList = (classId: string, page: any) => {
  return http.get(`/vote/public/controller.php?enews=news-list`, {
    params: {
      classId,
      page,
    },
  });
};

const getRules = () => {
  return http.get(`${urlPrefix}rules`);
};

const ifRegister = (wxId: string) => {
  return http.post(
    `${urlPrefix}if_register`,
    qs.stringify({
      unionid: wxId,
    }),
  );
};

const register = (data: any) => {
  return http.post(`${urlPrefix}register`, qs.stringify(data));
};
// 用户信息
const userInfo = (id?: string) => {
  return http.post(
    `${urlPrefix}user-info`,
    qs.stringify({
      unionid: id,
    }),
  );
};

const bgImgList = () => {
  return http.get(`${urlPrefix}background-list`);
};
const titleList = () => {
  return http.get(`${urlPrefix}title-list`);
};

const userList = (date: string, id?: string) => {
  return http.post(
    `${urlPrefix}user-list`,
    qs.stringify({
      time: date,
      unionid: id,
    }),
  );
};
// 打卡接口
const save = (data: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};
// 详情
const detail = (id: string, wxid?: string) => {
  return http.post(
    `${urlPrefix}detail&id=${id}`,
    qs.stringify({
      unionid: wxid,
    }),
  );
};
// 当天咖啡券剩余查询
const balance = () => {
  return http.get(`${urlPrefix}balance`);
};
// 图片检查
const coverCheck = (url: string) => {
  return http.post(
    `${urlPrefix}pictureCheck`,
    qs.stringify({
      imgUrl: url,
    }),
  );
};
// 兑换咖啡券
const convert = (machineid: string, id?: string) => {
  return http.post(
    `${urlPrefix}exchange`,
    qs.stringify({
      id: machineid,
      unionid: id,
    }),
  );
};

// 门店列表
const cardMachine = () => {
  return http.get(`${urlPrefix}card_machine`);
};
// 门店余额
const machineBalance = (id: string) => {
  return http.get(`${urlPrefix}balance-volume`, {
    params: {
      id,
    },
  });
};
const ifVote = (wxid: string, id: string) => {
  return http.post(
    `${urlPrefix}if-vote`,
    qs.stringify({
      unionid: wxid,
      id,
    }),
  );
};
const vote = (data: any) => {
  return http.post(`${urlPrefix}vote`, qs.stringify(data));
};

const homeInfo = () => {
  return http.post(`${urlPrefix}home-info`);
};

const orderList = () => {
  return http.get(`${urlPrefix}nowExchange`);
};
// 现场图片列表
const scenePic = () => {
  return http.get(`${urlPrefix}showScene`);
};

const getSceneType = () => {
  return http.get(`${urlPrefix}sceneType`);
};

const getSceneTypeList = () => {
  return http.get(`${urlPrefix}sceneTypeList`);
};

const getVoteList = () => {
  return http.get(`${urlPrefix}list`);
};

// 活动现场列表
export const getActImgList = (page: number, search: string, workType: any) => {
  return http.get(`${urlPrefix}sceneList`, {
    params: {
      page,
      search,
      workType,
    },
  });
};
// 活动现场详情
export const getDetail = (id: any) => {
  return http.get(`${urlPrefix}sceneDetail`, {
    params: {
      id,
    },
  });
};
// 用户上传列表
export const userUploadList = (id: string) => {
  return http.post(`${urlPrefix}sceneUserList`, qs.stringify({ unionid: id }));
};

// 上传
export const uploadActImg = (data: any) => {
  return http.post(`${urlPrefix}saveScene`, qs.stringify(data), {
    headers: {},
  });
};

export const updateActImg = (data: any) => {
  return http.post(`${urlPrefix}updateScene`, qs.stringify(data), {
    headers: {},
  });
};

export const ifFoodstuff = (data: any) => {
  return http.post(`${urlPrefix}if-foodstuff`, qs.stringify(data));
};

export const foodstuffSave = (data: any) => {
  return http.post(`${urlPrefix}foodstuffSave`, qs.stringify(data));
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

export {
  getBaseInfo,
  getWorks,
  getList,
  getRules,
  ifRegister,
  register,
  userInfo,
  bgImgList,
  titleList,
  userList,
  detail,
  save,
  balance,
  coverCheck,
  convert,
  cardMachine,
  machineBalance,
  ifVote,
  vote,
  homeInfo,
  orderList,
  scenePic,
  getVoteList,
  getNews,
  getSceneType,
  getSceneTypeList,
};
